/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeploymentPodsResponse } from '../models/DeploymentPodsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ScalingService {
    /**
     * Scale Api
     * Manually scale a deployment to the specified number of replicas.
     * Requires manager authentication.
     * @param replicaCount
     * @returns any Successful Response
     * @throws ApiError
     */
    public static scaleApiScaleApiReplicasReplicaCountPost(
        replicaCount: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/scale/api/replicas/{replica_count}',
            path: {
                'replica_count': replicaCount,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Pods
     * Get the current number of pods for the API deployment.
     * Requires manager authentication.
     * @returns DeploymentPodsResponse Successful Response
     * @throws ApiError
     */
    public static getPodsScaleApiPodsGet(): CancelablePromise<DeploymentPodsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/scale/api/pods',
        });
    }
}
